import { environment } from "../../environments/environment";

export function isExternalUrl(url: string): boolean {
    return !url.startsWith(environment.api.url);
}